<div class="row ss-top-menu">
	<div class="col-xl-12 col-lg-12 col-md-12 col-sm-9 col-xs-9">
		<span class="ss-text-light">Dashboard <i class="rightArrow fa fa-angle-right"></i></span>
    <span class="ss-text-dark">Incentives</span> 
	</div>
</div>


<div class="row mt-4 pl-4">

  <div class="col-md-3">
    <!-- <div class="card" style="width: 18rem;">
      <div class="card-body">
        <h5 class="card-title">Go To Champion Incentive</h5>
      </div>
    </div> -->

    <div class="card myCard-champion mb-4 text-center">
      <div class="card-body py-2">
        <div class="card-text mb-0">
          <div class="mt-3 mb-4 ml-2 mr-1">
            <div class="row">
              <div class="col-3">
                <img src="assets/v3/img/incentiveicon.png" class="my-2">
              </div>
              <div class="col-9 d-flex align-items-center addCursor mt-2" [routerLink]="['/incentive-list']">
                <span class="statusCardHeadingColor">Champion Incentive</span>
              </div>
            </div>
          </div>
          <!-- <div class="row">
            <div class="col-sm-12 p-0 pt-2 mt-4 capitalize addCursor" [routerLink]="['/incentive-list']">
             <span style="color: #8d0620;">Champion Incentive</span> 
            </div>
          </div> -->

      

        </div>
      </div>

    </div>

  </div>

  <div class="col-md-3">
    <div class="card myCard-champion mb-4 text-center">
      <div class="card-body py-2">
        <div class="card-text mb-0">
          <div class="mt-3 mb-4 ml-2 mr-1 mx-3">
            <div class="row">
              <div class="col-4">
                <img src="assets/v3/img/DeltaIncentiveImage.png" class="width mx-2 my-4">
              </div>
              <div class="col-8 d-flex align-items-center addCursor" [routerLink]="['/delta-incentive']">
                <span class="mb-4 statusCardHeadingColor" style="padding-bottom: 3PX; margin-bottom: 8px;">Delta Incentive</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

 

  

</div>




// WEBPACK FOOTER //
// ./src/app/platform/finance/incentive/incentive.component.html